
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("02nRr", function(module, exports) {
$parcel$export(module.exports, "register", () => $0072b2502976b004$export$6503ec6e8aabbaf, (v) => $0072b2502976b004$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0072b2502976b004$export$f7ad0328861e2f03, (v) => $0072b2502976b004$export$f7ad0328861e2f03 = v);
var $0072b2502976b004$export$6503ec6e8aabbaf;
var $0072b2502976b004$export$f7ad0328861e2f03;
"use strict";
var $0072b2502976b004$var$mapping = new Map();
function $0072b2502976b004$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0072b2502976b004$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0072b2502976b004$var$resolve(id) {
    var resolved = $0072b2502976b004$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0072b2502976b004$export$6503ec6e8aabbaf = $0072b2502976b004$var$register;
$0072b2502976b004$export$f7ad0328861e2f03 = $0072b2502976b004$var$resolve;

});

var $8b37b41adb562839$exports = {};

(parcelRequire("02nRr")).register(new URL("", import.meta.url).toString(), JSON.parse("[\"IOlTS\",\"SpaceSettingsNavigationPortal.14026a02.js\",\"bU3dV\",\"CopySpacePermissionsAndDefaultPermissions.bff47352.js\",\"eMbU0\",\"SpaceSelector.640767c9.js\",\"3wN5D\",\"ExternalSpaceLozenge.11ec98f6.js\",\"kC80R\",\"esm.7399a977.js\",\"h3ABO\",\"esm.dc8ab43b.js\",\"cjaF7\",\"custom-theme.622af4c8.js\",\"1F7LX\",\"manual-triggers-modal.1a75a671.js\",\"Wowvf\",\"vendors~editor_atlaskit_sm.647788d6.js\",\"hhss7\",\"vendors~editor_atlaskit_lg.e2f563b3.js\",\"7EorR\",\"vendors~editor_atlaskit_md.ec4caca3.js\",\"kuFG2\",\"link-extractors.978f4989.js\",\"1bbSu\",\"main.50b79dec.js\",\"fLwVm\",\"blockSubscription.67aadb75.js\",\"8k9aB\",\"blockSubscription.runtime.52d8db31.js\",\"bJVDE\",\"inlineCard.61f5e0cc.js\",\"aQh37\",\"inlineCard.runtime.8d235f81.js\",\"jXx9i\",\"NativeCollabComponent.5e274adb.js\",\"ffEVr\",\"vendors~editor_icon.70cd94e7.js\",\"dLq4a\",\"FullPageEditorComponent.6b07e864.js\",\"2tIxk\",\"FullPageEditorComponent.runtime.fdaf0009.js\",\"8bhm4\",\"component-lazy.ca1ea04a.js\",\"gT8XU\",\"page-icon.673a5f1e.js\",\"6wr18\",\"vendors~editor_icon.5e7921dd.js\",\"kO0mz\",\"audio-icon.a72b16ff.js\",\"jDjSj\",\"16.6620cf44.js\",\"gQLjx\",\"angle-brackets-icon.a9d79ce0.js\",\"kDqHr\",\"file-icon.2c21d90a.js\",\"5i5pX\",\"folder-icon.565821ef.js\",\"eA5B3\",\"image-icon.eb9c7b40.js\",\"4HZlX\",\"chart-bar-icon.579776d5.js\",\"7jSfd\",\"list-bullet-icon.ece0edd9.js\",\"7AsyI\",\"video-icon.479f765b.js\",\"jNyUd\",\"component.30faa9cf.js\",\"2fk6g\",\"16.870e5b83.js\",\"huUvS\",\"16.c7a24433.js\",\"1oiJ6\",\"16.ceea8ca3.js\",\"lxiFd\",\"16.107de1cf.js\",\"eDqo1\",\"16.d7d9d345.js\",\"6HBYC\",\"16.17e243ff.js\",\"bYxCZ\",\"16.6136e176.js\",\"eTBsW\",\"16.d641f87b.js\",\"020xd\",\"16.064dd092.js\",\"ls0Um\",\"16.f393c033.js\",\"eVYW1\",\"16.92462d06.js\",\"f35QR\",\"16.fe870969.js\",\"aOY32\",\"branch.d01b7829.js\",\"6fQco\",\"commit.1158727f.js\",\"1MWOL\",\"pull-request.31924fce.js\",\"9wPDc\",\"code.400ca607.js\",\"9atVd\",\"bug.a6bc0b2b.js\",\"lm9Lt\",\"changes.2efb1d96.js\",\"jiFtb\",\"epic.c15b1ce0.js\",\"4S1SF\",\"incident.4454116e.js\",\"XZauT\",\"problem.400a1674.js\",\"3MYQs\",\"work-item.dcc34231.js\",\"5zapo\",\"story.69c147c4.js\",\"9aQIt\",\"subtask.f25c64e5.js\",\"6SWFK\",\"task.0cf4140f.js\",\"87j6O\",\"jira-icon.eb7336b7.js\",\"lQhaj\",\"priority-blocker-icon.3cd4d067.js\",\"iEn0J\",\"priority-critical-icon.a16caea9.js\",\"d2etG\",\"priority-high-icon.2bcc7c3c.js\",\"2rWNg\",\"priority-highest-icon.eaa10f8e.js\",\"akInk\",\"priority-low-icon.36a704f7.js\",\"6zoNk\",\"priority-lowest-icon.25167aec.js\",\"1MCFU\",\"priority-major-icon.3bdaf893.js\",\"gz7jV\",\"priority-medium-icon.1b8d3b41.js\",\"5Bj6b\",\"priority-minor-icon.ab3c8219.js\",\"89ync\",\"priority-trivial-icon.33eeb7a6.js\",\"7aMek\",\"component-lazy.05b83332.js\",\"mhlT3\",\"SpaceSelector.720be3a3.js\",\"dtpmo\",\"SpaceSelector.ead533ff.js\",\"enBeB\",\"emoji.9a04c41b.js\",\"fVkwb\",\"emoji.runtime.3855c1ec.js\",\"fuks3\",\"CommentEditor.027a7fa6.js\",\"8k9aB\",\"blockSubscription.runtime.52d8db31.js\",\"aQh37\",\"inlineCard.runtime.8d235f81.js\",\"2tIxk\",\"FullPageEditorComponent.runtime.fdaf0009.js\",\"fVkwb\",\"emoji.runtime.3855c1ec.js\",\"4yUSc\",\"PremiumLozenge.d0aafec4.js\",\"ePA5l\",\"Lozenge.6b6c5ac2.js\",\"5pvpJ\",\"datasourceTableView.686437f9.js\",\"1yVM6\",\"UpgradeEditionButton.dfa9171d.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.9e699dd2.js\",\"6XCf4\",\"LearnMoreButton.a4aeb7b8.js\",\"cEqm7\",\"ExtensionConfigUpsell.9d31190c.js\",\"hOaAV\",\"ExtensionConfigUpsell.76ff350b.js\",\"amPsT\",\"InspectPermissionsDialog.52f50c34.js\",\"1qlDN\",\"UpgradeEditionButton.runtime.9e699dd2.js\",\"9LX74\",\"searchNoResults.7be90ed3.svg\"]"));


$parcel$global.rlb("DNq0w")
//# sourceMappingURL=SpaceSettingsNavigationPortal.runtime.7a9e8a71.js.map
